/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes, replacePXinStringWithEM } from 'utils/styles';



// ===================== ANIMATION : BOTTOM : PROGRESS BAR / SHARE SET ICONS ===================== //
const aniProgressBarShareBottomResult = {
    // ~~~~~~~~~~~~~~~~~~~~~ RESULT STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .resultelements': {
        height: 'auto',
        zIndex: '2',
        '& .progressbar.type-result': {
            animationName: 'fadeInUp',
            animationDelay: '1.3s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },
        '& .rewardsfeedback': {
            '& .icon': {
                animationName: 'fadeInUp',
                animationDelay: '1.8s',
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            },
            '& .text': {
                animationName: 'fadeInLeft',
                animationDelay: '2.3s',
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            }
        },
        '& .facebook': {
            animationName: 'fadeInUp',
            animationDelay: '2.6s',
            animationDuration: '.5s',
            animationFillMode: 'forwards'
        },
        '& .twitter': {
            animationName: 'fadeInUp',
            animationDelay: '2.9s',
            animationDuration: '.5s',
            animationFillMode: 'forwards'
        }
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniProgressBarShareBottomResult };